import React from 'react';
import { useTranslation } from 'react-i18next';
import PopoverWithTooltip from '../PopoverWithTooltip';
export var StatTooltip = function (_a) {
    var renderPopover = _a.renderPopover, tooltipKey = _a.tooltipKey, positionOnly = _a.positionOnly, children = _a.children;
    var t = useTranslation().t;
    return (React.createElement(PopoverWithTooltip, { tooltip: tooltipKey && t(tooltipKey), renderPopover: renderPopover, positionOnly: positionOnly, showArrow: !positionOnly }, children));
};
StatTooltip.displayName = 'StatTooltip';
export default StatTooltip;
//# sourceMappingURL=StatTooltip.js.map